import angular from 'angular';
import commonModule from '../common';
import coreModule from '../core';

angular.module('7Terminal.Peripherals', [
  coreModule,
  commonModule
]);
